export const TYPE_OPTS = {
  default: 'bg-white',
  success: 'bg-utility-success-base',
  info: 'bg-utility-info-base',
  danger: 'bg-utility-danger-base',
  warning: 'bg-utility-warning-base',
  neutral: 'bg-disabled',
};

export const SIZE_OPTS = {
  sm: 'h-1.5 w-1.5',
  default: 'h-2 w-2',
  md: 'h-ds-12 w-ds-12',
  lg: 'h-4 w-4',
};
